import { FlatfileRecord } from '@flatfile/hooks';
import { FIELD_TYPE, submitAction } from 'components/imports/blueprintUtils';
import { MAX_STR_LENGTH, nullable, required } from 'components/imports/schemaUtils';
import { ImportStrategy } from 'components/imports/types';
import { yup } from 'helpers/yup';
import { ValidationError } from 'yup';

const fundSchema = yup.object().shape({
    name: required.label('Name').max(MAX_STR_LENGTH),
    code: nullable.label('Code').max(MAX_STR_LENGTH),
});

const useFundImportStrategy = (): ImportStrategy => {
    return {
        displayName: 'funds',
        type: 'funds',
        hasDownloadTemplate: true,
        blueprint: {
            name: 'Import funds',
            sheets: [
                {
                    name: 'Funds',
                    slug: 'funds',
                    fields: [
                        {
                            label: 'Name',
                            key: 'name',
                            type: FIELD_TYPE.string,
                        },
                        {
                            label: 'Code',
                            key: 'code',
                            type: FIELD_TYPE.string,
                            constraints: [
                                {
                                    type: 'unique',
                                },
                            ],
                        },
                    ],
                },
            ],
            actions: [submitAction],
        },
        recordHook: (record: FlatfileRecord) => {
            const data = record.value;

            const context = {};

            try {
                fundSchema.validateSync(data, { context, abortEarly: false });
            } catch (err) {
                if (!(err instanceof ValidationError)) {
                    return record;
                }

                if (!err.inner && err.path) {
                    record.addError(err.path, err.message);

                    return record;
                }

                err.inner.forEach(e => {
                    if (e.path) {
                        record.addError(e.path, e.message);
                    }
                });
            }

            return record;
        },
    };
};

export { useFundImportStrategy };
